export default __webpack_public_path__ + "static/media/incoming-green.d58337d6.svg";